import React from "react";

function FileInput({ handleChange, errorMessage }) {
  return (
    <div className="col-sm-6 mb-3">
      <div className="form-floating">
        <input
          className="form-control boxshadow-none outline-none"
          type="file"
          name="idImage"
          id="idImage"
          onChange={handleChange}
          accept="image/jpg, image/jpeg, image/png"
        />
        <label htmlFor="idImage">Id Picture</label>
      </div>
      {errorMessage && (
        <div className="invalid-feedback d-block">{errorMessage}</div>
      )}
    </div>
  );
}

export default FileInput;
